import React, { memo } from 'react'
import { ControlledTextInput } from 'transfix-form/components'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from 'apps/marketplace/pages/create-shipment/context'
import { TReeferSchema } from 'apps/marketplace/pages/create-shipment/schema/EquipmentDetailsSchema/EquipmentReeferSchema'
import { getEquipmentAttributeErrorMessage } from 'apps/marketplace/pages/create-shipment/utils'
import { TReeferSchemaErrors } from '../ReeferEquipmentFormSection/types'

export interface ISecuringOptionsFormSectionProps {}

const getNumberValue = (val: string) => Number(val) || undefined

const SecuringOptionsFormSection = memo<ISecuringOptionsFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useCreateShipmentFormContext()
  const { equipmentAttributes } = errors || {}
  const equipmentAttributesErrors = equipmentAttributes as TReeferSchemaErrors

  const getErrorMessage = (keyName: keyof TReeferSchemaErrors) => {
    return getEquipmentAttributeErrorMessage<TReeferSchema>(equipmentAttributesErrors, keyName)
  }

  return (
    <div>
      <Typography variant='subtitle1'>Securing Options</Typography>
      <div>
        <ControlledCheckbox
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.load_bars}`}
          CheckboxProps={{
            label: 'Load Bars',
            dataTest: 'load-bars-field',
          }}
        />
      </div>
      <div>
        <ControlledCheckbox
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.load_locks}`}
          CheckboxProps={{
            label: 'Load Locks',
            dataTest: 'load-locks-field',
          }}
        />
      </div>
      <div>
        <ControlledTextInput
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.straps}`}
          mutateValue={getNumberValue}
          TextInputProps={{
            type: 'number',
            label: 'Straps',
            placeholder: '#',
            dataTest: 'straps-field',
            error: !!getErrorMessage(IEquipmentAttributeTypes.straps),
            validationMessage: getErrorMessage(IEquipmentAttributeTypes.straps),
          }}
        />
      </div>
    </div>
  )
})

export default SecuringOptionsFormSection
